var _a, _b;
import * as tslib_1 from "tslib";
import { handleActions, combineActions } from 'redux-actions';
import { reduxKey, defaultState } from './constants';
import { enterZoomMode, exitZoomMode, showPanel, hidePanel, hidePanelPopup, setScreenSize, } from './actions';
import { setViewMode } from '../../publicSession/actions';
import { unloadDuperbrowseItem, exitDuperbrowseDone, } from '../../Duperbrowse/redux/actionCreators';
var actionHandlers = handleActions((_a = {},
    _a[setViewMode.toString()] = function (state, _a) {
        var _b = _a.payload, nextViewMode = _b.nextViewMode, currentViewMode = _b.currentViewMode;
        return (tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { isInZoom: nextViewMode !== currentViewMode ? false : state.viewOptions.isInZoom }) }));
    },
    _a[enterZoomMode.toString()] = function (state) { return (tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { isInZoom: true }) })); },
    _a[exitZoomMode.toString()] = function (state) { return (tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { isInZoom: false }) })); },
    _a[showPanel.toString()] = function (state, _a) {
        var _b = _a.payload, _c = _b.actionBar, actionBar = _c === void 0 ? 'primary' : _c, panelType = _b.panelType;
        return (tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { visiblePanel: panelType, activeActionBar: actionBar }) }));
    },
    _a[hidePanel.toString()] = function (state, _a) {
        var panelType = _a.payload.panelType;
        return state.viewOptions.visiblePanel === panelType
            ? tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { visiblePanel: false, activeActionBar: 'primary' }) }) : state;
    },
    _a[combineActions(unloadDuperbrowseItem, exitDuperbrowseDone).toString()] = function (state) {
        return state.viewOptions.visiblePanel
            ? tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { visiblePanel: false, activeActionBar: 'primary' }) }) : state;
    },
    _a[hidePanelPopup.toString()] = function (state) { return (tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { visiblePanel: false, activeActionBar: 'primary' }) })); },
    _a[setScreenSize.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { viewOptions: tslib_1.__assign({}, state.viewOptions, { screenSize: action.payload }) })); },
    _a), defaultState);
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map